import XLSX from 'xlsx-js-style'

// Função auxiliar para verificar se a string é um número puro (apenas dígitos e opcional ponto)
function isNumericString(str) {
  if (typeof str !== 'string') return false
  return /^[0-9]+(\.[0-9]+)?$/.test(str.trim())
}

// Mapeamento de estilos do Univer para xlsx-js-style
function translateUniverStyle(styleName) {
  const styleMap = {
    sectionTitle: {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '3F51B5' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    header: {
      fill: { fgColor: { rgb: 'C8E6C9' } },
      font: { bold: true, color: { rgb: '000000' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    locked: {
      fill: { fgColor: { rgb: 'F5F5F5' } },
      alignment: { horizontal: 'left', vertical: 'middle' },
    },
    lockedNumber: {
      fill: { fgColor: { rgb: 'F5F5F5' } },
      numFmt: '0',
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    lockedCurrency: {
      fill: { fgColor: { rgb: 'F5F5F5' } },
      numFmt: '"R$ "#,##0.00',
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    lockedDate: {
      fill: { fgColor: { rgb: 'F5F5F5' } },
      numFmt: 'dd/mm/yyyy',
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    lockedDateTime: {
      fill: { fgColor: { rgb: 'F5F5F5' } },
      numFmt: 'dd/mm/yyyy hh:mm',
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    lockedDateShort: {
      fill: { fgColor: { rgb: 'F5F5F5' } },
      numFmt: 'dd/mm/yy',
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    editable: {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      alignment: { horizontal: 'left', vertical: 'middle' },
    },
    editableNumber: {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      numFmt: '0',
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    editableCurrency: {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      numFmt: '"R$ "#,##0.00',
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    editableDate: {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      numFmt: 'dd/mm/yyyy',
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    editableDateTime: {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      numFmt: 'dd/mm/yyyy hh:mm',
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    positiveNumber: {
      fill: { fgColor: { rgb: 'C8E6C9' } },
      numFmt: '0',
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    negativeNumber: {
      fill: { fgColor: { rgb: 'FFCDD2' } },
      font: { color: { rgb: 'C62828' } },
      numFmt: '0',
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    totalLabel: {
      font: { bold: true },
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    totalCurrency: {
      fill: { fgColor: { rgb: 'C8E6C9' } },
      numFmt: '"R$ "#,##0.00',
      font: { bold: true },
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    totalNumber: {
      fill: { fgColor: { rgb: 'C8E6C9' } },
      numFmt: '0',
      font: { bold: true },
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
    statusRented: {
      fill: { fgColor: { rgb: 'C8E6C9' } },
      font: { color: { rgb: '1B5E20' } },
    },
    statusReserved: {
      fill: { fgColor: { rgb: 'FFF9C4' } },
      font: { color: { rgb: 'F57F17' } },
    },
    statusReturned: {
      fill: { fgColor: { rgb: 'E1F5FE' } },
      font: { color: { rgb: '0D47A1' } },
    },
    exchangeSectionTitle: {
      font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 12 },
      fill: { fgColor: { rgb: 'C62828' } }, // Vermelho escuro rgb(198,40,40)
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    exchangeHeader: {
      fill: { fgColor: { rgb: 'FFCDD2' } }, // Vermelho claro rgb(255,205,210)
      font: { bold: true, color: { rgb: '000000' } },
      alignment: { horizontal: 'center', vertical: 'middle' },
    },
    exchangeTotalCurrency: {
      fill: { fgColor: { rgb: 'FFCDD2' } }, // Vermelho claro rgb(255,205,210)
      font: { bold: true, color: { rgb: 'C62828' } }, // Texto vermelho escuro
      numFmt: '"R$ "#,##0.00',
      alignment: { horizontal: 'right', vertical: 'middle' },
    },
  }
  return styleMap[styleName] || null
}

export function convertSnapshotToXLSX(snapshot, options = {}) {
  const { includeFormulas = true } = options
  const workbook = XLSX.utils.book_new()

  if (!snapshot || !snapshot.sheets) {
    console.warn('Snapshot inválido ou sem sheets.')
    return workbook
  }

  const sheetNames = snapshot.sheetOrder || Object.keys(snapshot.sheets)
  if (sheetNames.length === 0) {
    console.warn('Nenhuma sheet encontrada no snapshot.')
    return workbook
  }

  sheetNames.forEach((sheetName) => {
    const sheetData = snapshot.sheets[sheetName]
    if (!sheetData) return

    const { cellData = {}, mergeData = [], columnData = {} } = sheetData

    let maxRow = 0
    let maxCol = 0
    Object.keys(cellData).forEach((rowKey) => {
      const row = parseInt(rowKey, 10)
      if (row > maxRow) maxRow = row
      const cols = Object.keys(cellData[rowKey])
      cols.forEach((colKey) => {
        const col = parseInt(colKey, 10)
        if (col > maxCol) maxCol = col
      })
    })

    if (maxRow === 0 && maxCol === 0) {
      const ws = XLSX.utils.aoa_to_sheet([['Sem dados na planilha']])
      XLSX.utils.book_append_sheet(workbook, ws, sheetName)
      return
    }

    // === 1. Construir dataRows com valores normalizados ===
    const dataRows = []
    for (let r = 0; r <= maxRow; r++) {
      const rowData = []
      for (let c = 0; c <= maxCol; c++) {
        const cell = cellData[r]?.[c]
        if (cell) {
          // Tratar datas
          if (cell.t === 2 && cell.s && cell.s.includes('date')) {
            if (typeof cell.v === 'number') {
              const excelEpoch = new Date(1899, 11, 30)
              const date = new Date(excelEpoch.getTime() + cell.v * 86400000)
              rowData[c] = date
            } else {
              rowData[c] = cell.v
            }
          } else {
            let value = cell.v
            // Se for string, verificar se é numérica pura
            if (typeof value === 'string' && isNumericString(value)) {
              const num = parseFloat(value)
              rowData[c] = isNaN(num) ? value : num
            } else if (typeof value === 'number') {
              rowData[c] = value
            } else {
              rowData[c] = value ?? ''
            }
          }
        } else {
          rowData[c] = ''
        }
      }
      dataRows.push(rowData)
    }

    const ws = XLSX.utils.aoa_to_sheet(dataRows)

    // === 2. Aplicar fórmulas e estilos célula por célula ===
    for (let r = 0; r <= maxRow; r++) {
      for (let c = 0; c <= maxCol; c++) {
        const cellDataItem = cellData[r]?.[c]
        if (!cellDataItem) continue

        const cellAddress = XLSX.utils.encode_cell({ r, c })
        if (!ws[cellAddress]) {
          ws[cellAddress] = { v: '' }
        }

        // Aplicar fórmula
        if (includeFormulas && cellDataItem.f) {
          let formula = String(cellDataItem.f).replace(/^=+/, '')
          if (formula) {
            ws[cellAddress].f = formula
            ws[cellAddress].t = 'n'
            if (cellDataItem.v !== undefined) {
              ws[cellAddress].v = cellDataItem.v
            }
          }
        }

        // Aplicar estilo
        if (cellDataItem.s) {
          const styleConfig = translateUniverStyle(cellDataItem.s)
          if (styleConfig) {
            ws[cellAddress].s = styleConfig
          }
        }
      }
    }

    // Merges
    if (mergeData && mergeData.length > 0) {
      ws['!merges'] = mergeData.map((merge) => ({
        s: { r: merge.startRow, c: merge.startColumn },
        e: { r: merge.endRow, c: merge.endColumn },
      }))
    }

    // Larguras de coluna
    if (columnData) {
      const colKeys = Object.keys(columnData).map(Number)
      if (colKeys.length > 0) {
        const maxColIdx = Math.max(...colKeys)
        const colWidths = []
        for (let c = 0; c <= maxColIdx; c++) {
          const colInfo = columnData[c]
          colWidths.push({ wch: colInfo?.w ? Math.round(colInfo.w / 7) : 12 })
        }
        ws['!cols'] = colWidths
      }
    }

    XLSX.utils.book_append_sheet(workbook, ws, sheetName)
  })

  return workbook
}
